import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20animation%20artist%20workspace%20with%20drawing%20tablet%20storyboard%20sketches%20soft%20warm%20lighting%20creative%20studio%20atmosphere%20artistic%20illustration%20style%20gentle%20amber%20and%20cream%20tones%20traditional%20meets%20digital%20art%20vibe%20hand%20drawn%20animation%20cells%20scattered%20on%20wooden%20desk&width=1600&height=900&seq=hero-banner-01&orientation=landscape"
        alt="同人动画创作指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 md:mb-6 leading-tight">
            同人动画创作指南
          </h1>
          <p className="text-background-200 text-base md:text-xl mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
            从零到成品，让你的故事动起来 —— 深入了解同人动画的创作流程、工具选择与发布渠道
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/tutorials"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始学习
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 text-background-50 font-medium hover:bg-background-50/30 backdrop-blur-sm transition-colors whitespace-nowrap"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}